import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { _className, Button, ComponentSync, EditableDBItemV3, LL_H_C, LL_V_L, SimpleListAdapter, TS_DropDown, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { FadeScrollWrapper } from '@app/styles';
import { ModuleFE_FlowSheet } from '@app/advisor-content-frontend/index';
import { DropDown_FlowSheet } from '@app/advisor-content-frontend/_entity/flow-sheet/ui-components';
import './Editor_Organization_InstallationFlowSheets.scss';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { DocStatuses } from '@app/org-shared';
import { ModuleFE_InstallationFlowsheetConfiguration } from '../../../../../_entity/installation/index.js';
import { ViewKey_Edit, ViewKey_View } from '../../../consts.js';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
export class Editor_Organization_InstallationFlowSheets extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.ehrInstallationId = nextProps.ehrInstallationId;
        state.editMode = nextProps.editMode;
        if (state.ehrInstallationId !== this.state?.ehrInstallationId)
            state.editable = undefined;
        if (!state.editable) {
            const flowSheetConfigs = this.getFlowSheetConfigs(state.ehrInstallationId);
            state.editable = this.getEditable(flowSheetConfigs[0]);
        }
        return state;
    }
    // ######################## Logic ########################
    getFlowSheetConfigs(ehrInstallationId) {
        return ModuleFE_InstallationFlowsheetConfiguration.cache.filter(fsc => fsc.ehrInstallationId === ehrInstallationId);
    }
    getEditable(flowSheetConfig) {
        if (!flowSheetConfig)
            return;
        const isNew = !flowSheetConfig._id;
        const editable = new EditableDBItemV3(flowSheetConfig, ModuleFE_InstallationFlowsheetConfiguration);
        editable.setAutoSave(!isNew);
        editable.setOnSaveCompleted(config => {
            if (isNew)
                return this.setState({ editable: this.getEditable(config) });
            this.forceUpdate();
        });
        editable.setOnDelete(async () => {
            if (!flowSheetConfig._id)
                return;
            await ModuleFE_InstallationFlowsheetConfiguration.v1.delete(flowSheetConfig).executeSync();
            this.setState({ editable: undefined });
        });
        return editable;
    }
    createNewConfig = () => {
        const newConfig = { ehrInstallationId: this.state.ehrInstallationId, label: '' };
        const editable = this.getEditable(newConfig);
        this.setState({ editable });
    };
    getViewMode = () => this.state.editMode ? ViewKey_Edit : ViewKey_View;
    // ######################## Render ########################
    render() {
        return _jsxs(LL_H_C, { className: 'editor__ehr-flowsheet-config', children: [this.render_ConfigList(), this.render_ConfigEditor()] });
    }
    // ######################## Render - List ########################
    render_ConfigList = () => {
        return _jsxs(LL_V_L, { className: 'editor__ehr-flowsheet-config__config-list', children: [this.render_ConfigList_Controls(), this.render_ConfigList_Items()] });
    };
    render_ConfigList_Controls = () => {
        if (!this.state.editMode)
            return;
        return _jsx(LL_V_L, { className: 'editor__ehr-flowsheet-config__controls', children: _jsx(Button, { onClick: this.createNewConfig, children: "New Config" }) });
    };
    render_ConfigList_Items = () => {
        const editable = this.state.editable;
        const configs = this.getFlowSheetConfigs(this.state.ehrInstallationId);
        return _jsxs(FadeScrollWrapper, { children: [!!editable && !editable.item._id && _jsx("div", { className: 'editor__ehr-flowsheet-config__config-list__item selected', children: "New Config" }), configs.map(config => {
                    const className = _className('editor__ehr-flowsheet-config__config-list__item', config._id === editable?.item._id && 'selected');
                    const dbFlowSheet = ModuleFE_FlowSheet.cache.unique(config.dbNoteId);
                    return _jsx("div", { className: className, onClick: () => {
                            this.setState({ editable: this.getEditable(config) });
                        }, children: config.label ?? dbFlowSheet?.label ?? 'N/A' }, config._id);
                })] });
    };
    // ######################## Render - Editor ########################
    render_ConfigEditor = () => {
        if (!this.state.editable)
            return;
        return _jsxs(LL_V_L, { className: 'editor__ehr-flowsheet-config__editor', children: [this.render_ConfigEditor_Actions(), this.render_ConfigEditor_Label(), this.render_ConfigEditor_DBFlowSheet(), this.render_ConfigEditor_FlowSheetId(), this.render_ConfigEditor_DocStatus()] });
    };
    render_ConfigEditor_Actions = () => {
        if (!this.state.editMode)
            return;
        const editable = this.state.editable;
        return _jsxs(LL_H_C, { className: 'editor__ehr-flowsheet-config__editor__actions', children: [!editable.item._id &&
                    _jsx(Button, { onClick: () => editable.save(), variant: 'primary', children: "Save" }), !!editable.item._id &&
                    _jsx(Button, { variant: 'dangerous', onClick: () => editable.delete(), children: "Delete" })] });
    };
    render_ConfigEditor_Label = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(DefaultEditor_InputText, { editable: editable, disabled: !this.state.editMode, prop: 'label' }) });
    };
    render_ConfigEditor_DBFlowSheet = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Quai Note', children: _jsx(DropDown_FlowSheet.editable, { editable: editable, disabled: !this.state.editMode, prop: 'dbNoteId' }) });
    };
    render_ConfigEditor_FlowSheetId = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Installation Note ID', children: _jsx(DefaultEditor_InputText, { editable: editable, prop: 'installationNoteCode', disabled: !this.state.editMode }) });
    };
    render_ConfigEditor_DocStatus = () => {
        const editable = this.state.editable;
        const adapter = SimpleListAdapter([...DocStatuses], item => _jsx(_Fragment, { children: item.item }));
        return _jsx(TS_PropRenderer.Vertical, { label: 'Doc Status', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => _jsx("div", { className: 'grid-data', children: editable.item.docStatus ?? '-' })
                    },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(TS_DropDown, { adapter: adapter, selected: editable.item.docStatus, onSelected: docStatus => editable.updateObj({ docStatus }) })
                    }
                ] }) });
    };
}
//# sourceMappingURL=Editor_Organization_InstallationFlowSheets.js.map